<div class="flex flex-col">

  <div class="flex flex-row justify-between">

    <h1 class="app-title">SKO</h1>

    <div class="flex flex-row"
      *ngIf="user()">

      <a color="primary" mat-icon-button routerLink="/make-call"><mat-icon>call</mat-icon></a>

      <a color="primary" mat-icon-button routerLink="/send-message"><mat-icon>sms</mat-icon></a>

    </div>

    <div class="flex flex-col">

      <div class="flex flex-row"
        *ngIf="!user()">

        <a mat-raised-button routerLink="/sign-in">Sign In</a>

      </div>

      <div class="flex flex-row"
        *ngIf="user() as user">

        <span>{{user.given_name}}</span>

      </div>

    </div>

  </div>

  <div class="route-container">

    <router-outlet></router-outlet>

    <div class="route-loading"
      *ngIf="routeLoading()">

      <mat-spinner></mat-spinner>

    </div>

  </div>

</div>
